// extracted by mini-css-extract-plugin
module.exports = {"aggregator-hero-wrapper__description":"aggregator-hero-wrapper_aggregator-hero-wrapper__description__z5mmM"};